import Submit from '~/components/button/Submit';
import Form from '~/components/Form';
import Field from '~/components/form-controls/Field';
import RadioGroup, {
  ButtonOption,
} from '~/components/form-controls/RadioGroup';
import Page from '~/components/layout/page/Page';
import { INPUT_NAME, useActionResult, useLoaderData } from './reasonDetail';

export default function ReasonDetailPage() {
  const {
    reasonDetailOptions,
    draftClaimLineItem: { reasonDetailId: selectedReasonDetail },
  } = useLoaderData();
  const actionResult = useActionResult();

  return (
    <Page.Section title="Got it. Can you provide a little more detail?">
      <Form name="reasonDetail">
        <RadioGroup className="mt-2" label="Select a reason" showLabel={false}>
          {reasonDetailOptions.map((reason) => (
            <ButtonOption
              key={reason.id}
              value={reason.id}
              name={INPUT_NAME}
              defaultChecked={reason.id === selectedReasonDetail}
              required
            >
              {reason.name}
            </ButtonOption>
          ))}
        </RadioGroup>
        {actionResult?.ok === false && (
          <Field.ErrorText>{actionResult.message}</Field.ErrorText>
        )}
        <Submit>Next</Submit>
      </Form>
    </Page.Section>
  );
}
